import { Component, OnInit, Input } from '@angular/core';
// tslint:disable:max-line-length
import { BitfMatSidenavService } from '@common/libs/bitforce/core/services/sidenav/material/bitf-mat-sidenav.service';
// tslint:enable:max-line-length

import { EFormMode } from '@common/enums/common.enum';
import { FsFilterComponent } from '../fs-filter/fs-filter.component';
import { EBitfSidenavMode, EBitfSidenavPosition } from '@enums';
import { FsStore } from '@models';

@Component({
  selector: 'prada-fs-filter-button',
  templateUrl: './fs-filter-button.component.html',
  styleUrls: ['./fs-filter-button.component.scss'],
})
export class FsFilterButtonComponent implements OnInit {
  @Input() fsStore: FsStore;

  constructor(private mSidenavService: BitfMatSidenavService) {}

  ngOnInit() {}

  openSidenav() {
    this.mSidenavService.open({
      component: FsFilterComponent,
      sidenavOptions: { mode: EBitfSidenavMode.OVER, position: EBitfSidenavPosition.END },
      componentData: {
        mode: EFormMode.FILTER,
        fsStore: this.fsStore,
      },
    });
  }
}
